import React, { useContext, useState } from "react";
import { NavLink, Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import AuthContext from "../../../laco-common/auth/AuthContext";
import { IAuthContext } from "../../../laco-common/base/auth";
import { UserRole, IUserProfileData, IUserAuthPayload } from "../../../laco-common/base/models/user";
import { UIStyleProps } from "../../ui/UIComponents";

type UserRoleContentProps = {
	roles?: UserRole[];
	profilePropRequired?: keyof IUserProfileData;
	renderCustomRejectContent?: (userPayload: IUserAuthPayload) => React.ReactNode | any;
	children: React.ReactNode;
	authMessageSuffix?: string | React.ReactNode;
	noAuthMessage?: boolean;
	skipAuth?: boolean;
} & RouteComponentProps &
	UIStyleProps;

const UserRoleContent: React.FC<UserRoleContentProps> = (props: UserRoleContentProps) => {
	const context: IAuthContext = useContext(AuthContext);
	const [redirect, setRedirect] = React.useState<boolean>(false);

	if (redirect) return <Redirect to={{ pathname: "/login", state: { redirectedFrom: props.location } }} />;

	const content = <React.Fragment key={context.uid}>{props.children}</React.Fragment>;

	if (props.skipAuth) return content;
	if (!context.isAuthenticated) {
		if (props.noAuthMessage) return null;
		if (props.renderCustomRejectContent) return props.renderCustomRejectContent(context.userPayload);
		return (
			<div className={props.className}>
				Please{" "}
				<span className="link" onClick={() => setRedirect(true)}>
					login
				</span>{" "}
				to view {props.authMessageSuffix || "content"}.
			</div>
		);
	}
	if (context.userPayload.superAdmin) return content;
	if (props.roles && !props.roles.includes(context.userPayload.role)) return null;
	if (props.profilePropRequired && !context.userPayload.profile[props.profilePropRequired])
		return (
			<>
				{props.renderCustomRejectContent ? (
					props.renderCustomRejectContent(context.userPayload)
				) : (
					<div className={props.className}>Can't access content.</div>
				)}
			</>
		);
	return content;
};

export default withRouter(UserRoleContent);
